<!-- joinUs -->
<template>
  <div class="joinUs">
    <div class="bgBox section1 ">
      <div class="s1_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>JOIN </span>US
          </div>
          <div class="p2"></div>
          <div class="p4">
            Talent recruitment
          </div>
          <div class="p5">
            <div class="phoneBox">
              <img src="../../static/images/contact/服务热线.png" alt="">
              <span>+86 0755-29128850 / +86 134 1007 8672</span>
            </div>
            <div class="emailBox">
              <img src="../../static/images/contact/邮箱.png" alt="">
              <span>hr@levimelt.com</span>
            </div>
          </div>
        </div>
        <div class="bodyBox">
          <div class="item" :class="active==1?'active':''" @click="section1Func(1)">Technical engineer</div>
          <div class="item" :class="active==2?'active':''" @click="section1Func(2)">Sales manager</div>
          <div class="item" :class="active==3?'active':''" @click="section1Func(3)">Purchasing manager</div>
          <div class="item" :class="active==4?'active':''" @click="section1Func(4)">Administrative manager</div>
        </div>
      </div>
    </div>
    <div class="bgBox sectionItem " v-for="(data,index) in obj[active]" :key="data.name">
      <div class="innerBox typeArea">
        <div class="commBox" :class="(index+1)%2==0?'right':''">
          <div class="labelBox">
            <div class="span">
              {{data.name}}
            </div>
            <div class="line"></div>
          </div>
          <div class="contentBox">
            <div class="tips">Job requirements:</div>
            <div class="item" v-for="item1 in data.items1" :key="item1">{{item1}}</div>

            <div class="tips cons">machinery design:</div>
            <div class="item" v-for="item2 in data.items2" :key="item2">{{item2}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'joinUs',
    components: {},
    data() {
      return {
        active: 1,
        obj: {
          1: [{
            name: 'Vacuum melting equipment structural design engineer',
            items1: [
              "1. Responsible for organizing the product structure design and development of vacuum equipment;",
              "2. Responsible for vacuum equipment scheme design;",
              "3. Responsible for guiding and participating in the structure design of vacuum equipment and selection of standard parts;",
              "4. Responsible for organizational structure research and development technology;",
              "5. Guide the assembly and trial production of the equipment and prepare the installation process documents;",
              "6. Responsible for organizing and dealing with technical problems of customer transfer."
            ],
            items2: [
              "1. Bachelor degree or above, major in mechanical design and automation, mechatronics, material processing, etc.",
              "2. Have a strong theoretical level of mechanical design, familiar with Solidworks, Auto-CAD and other mechanical design software;",
              "3. Have rich vacuum expertise, familiar with process and materials;",
              "4. More than 5 years experience in vacuum equipment and fluid machinery design;",
              "5. Experience in the research and development of single and continuous line vacuum equipment is preferred.",
            ]
          }, {
            name: 'Machining technology engineer',
            items1: [
              "1. Responsible for product production process design, review and verification;",
              "2. Review and proofread drawings;",
              "3. Prepare work instructions and other process documents;",
              "4. Preparation of components technology (the main processing technology of parts includes blanking, turning, milling, laser cutting, bending, deburring, marking, inspection, warehousing, etc.; Component processing technology mainly includes spare parts, cleaning, pre-assembly, vacuum brazing, argon arc welding, brazing, turning/milling, deburring, air sealing, inspection, storage, etc.);",
              "5. Develop production technology and follow up factory processing and production;",
              "6. Improve the existing production process to improve production efficiency;",
              "7. Can operate the cutting independently.",

            ],
            items2: [
              "1. Bachelor degree or above, major in vehicle engineering, machinery manufacturing, industrial design, etc.",
              "2. More than 3 years working experience, auto parts industry process engineer experience is preferred;",
              "3. Proficient in using a 3D design software;",
              "4. Can carry out simple fixture design;",
              "5. Clear thinking and careful thinking; Have good team management ability and collaborative spirit, work initiative, strong execution.",
            ]
          }, {
            name: 'Vacuum melting engineer',
            items1: [
              "1. Responsible for organizing vacuum equipment melting production;",
              "2. Repair and maintain vacuum melting equipment.",
            ],
            items2: [
              "1. Bachelor degree or above, major in metal materials and process equipment;",
              "2. Familiar with physical metallurgy technology and process methods, especially vacuum melting technology experience;",
              "3. Have rich vacuum expertise, familiar with process and materials;",
              "4. More than 3 years of professional work experience;",
              "5. With vacuum melting equipment maintenance and use ability.",
            ]
          }],
          2: [{
              name: 'Sales manager',
              items1: [
                "1. Actively carry out various sales work as planned and strive to complete the sales targets issued by the company (material direction, vacuum suspension melting equipment, etc.);",
                "2. Independently develop new customers and track old customers (equipment: vacuum suspension equipment; Materials: high entropy alloy, target material, composite fluid collection), to ensure the quantity and quality of new customer development;",
                "3. Fully understand the needs of potential customers and accurately grasp the progress of each stage of the project;",
                "4. Collect, sort out and analyze market information, understand the needs of potential customers, and assist the company to improve its competitive advantage;",
                "5. Grasp the market development and customer needs in real time, regularly provide sales analysis and forecast reports to the company, and regularly organize and arrange customer visits by manufacturers and technical personnel",
                "6. According to the needs of the company's development, constantly learn new knowledge and new technologies to improve my professional ability and career.",
              ],
              items2: [
                "1. College degree or above, science and engineering is preferred, with daily English reading and writing ability is preferred;",
                "2. Must have sales experience of vacuum suspension melting equipment or sales experience of high entropy alloy, target material and composite fluid collector;",
                "3. Understanding metal/oxide and other new material R&D equipment/process equipment/testing equipment class is preferred;",
                "4. Understanding semiconductor process equipment/packaging equipment/testing equipment is preferred, followed by large-scale instruments and equipment.",
              ]
            },
            {
              name: 'Sales assistant',
              items1: [
                "1. Responsible for the channel development and marketing of vacuum mechanical equipment products;",
                "2. To provide customers with non-standard equipment professional technical support;",
                "3. Develop new customers, maintain good customer relations, and expand the market share of products;",
                "4. Achieve sales business targets;",
                "5. Can independently complete the preparation and review of sales, after-sales and other related contracts;",
                "6. Responsible for other tasks assigned by superiors.",
              ],
              items2: [
                "1. Under 30 years old, no professional requirements, have a driver's license to drive, have a strong sense of responsibility, hard-working, studious, can quickly grasp the equipment knowledge;",
                "2. Good image, good temperament, strong communication skills, familiar with business etiquette;",
                "3. Experience in vacuum equipment sales is preferred;",
                "4. Metal materials related research resources are preferred;",
                "5. Familiar with national and industry standards;",
                "6. Video editing ability is preferred.",
              ]
            }
          ],
          3: [{
            name: 'Purchasing manager',
            items1: [
              "1. Independently search, evaluate, approve and improve suppliers;",
              "2. Identify qualified suppliers or develop new suppliers to carry out procurement activities (inquiry, negotiation, signing, etc.);",
              "3. Quotation analysis, transaction terms and conditions negotiation, supplier identification;",
              "4. Coordinate with suppliers and internal departments to clarify requirements and quality issues;",
              "5. Create orders and handle delivery status to ensure delivery on time;",
              "6. Project management, making project plans, milestones, tracking lists and timely updates to meet project needs at any time;",
              "7. Manage relationships with suppliers to drive continuous improvement in cost, delivery, quality and service;",
              "8. Maintain procurement data (supply sources, supply conditions, procurement contacts, etc.), maintain daily monitoring and update;",
              "9. Manage and file documents in daily work to ensure compliance with legal requirements and company policies.",
            ],
            items2: [
              "1. College degree or above, science and engineering preferred, with daily English reading and writing skills preferred;",
              "2. Good project management, price negotiation and data analysis skills;",
              "3. Project management experience is preferred;",
              "4. 3 years or above sales experience in machinery industry, independent development supplier ability;",
              "5. Understanding metal/oxide and other new material research and development equipment/process equipment/testing equipment class is preferred.",
            ]

          }],
          4: [{
            name: 'Administrative manager',
            items1: [
              "1. Network operation and maintenance;",
              "2. The company's overall office equipment maintenance;",
              "3. All kinds of office software, design software management;",
              "4. Output and management of video editing, digital content creation, operation and creative design;",
              "5. Responsible for mainstream social platforms and media operations;",
              "6. Assist the administration in dealing with daily work;",
              "7. Other tasks assigned by direct superiors or management.",
            ],
            items2: [
              "1. Bachelor degree or above;",
              "2. Excellent communication and coordination skills; Daily English reading and writing skills are preferred;",
              "3. Excellent writing ability, strong ability of information collection, material sorting and independent research;",
              "4. Mechanical industry promoters are preferred.",
            ]
          }]
        }
      }
    },
    computed: {},
    watch: {},
    created() {
      this.init()
    },
    mounted() {
      this.$store.commit('savePageId', '')
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    methods: {
      init() {

      },
      section1Func(data) {
        this.active = data
      }
    },
  }

</script>

<style lang='less' scoped>
  .joinUs {
    width: 100%;
    min-width: 1200px;

    .section1 {
      width: 100%;
      height: 614px;

      .s1_innerBox {
        height: 100%;

        .topTitle {
          .p1 {
            margin-top: 193px
          }

          .p4 {
            font-size: 16px;
            color: #333333;
            line-height: 16px;
            font-weight: 400;
            margin-top: 76px;
          }

          .p5 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 44px;
            background-color: #c30000;
            padding: 0 15px;
            color: #ffffff;
            font-size: 20px;
            font-weight: 400;
            margin-top: 22px;

            .phoneBox,
            .emailBox {
              display: flex;
              align-items: center;

              img {
                margin-right: 8px;
              }
            }

            .emailBox {
              margin-left: 50px;
            }
          }
        }

        .bodyBox {
          display: flex;
          margin-top: 59px;
          position: relative;

          .item {
            width: 300px;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 24px;
            color: #545454;
            font-weight: 400;
            background-color: #fbfbfb;
            cursor: pointer;
          }

          .item.active {
            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
            border: solid 1px #c30000;
            background-color: #ffffff;
            color: #c30000;
            font-weight: bold;
          }
        }
      }
    }

    .commBox {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .labelBox {
        width: 350px;
        height: 350px;
        border: solid 2px #c30000;
        padding: 18px 30px;
        font-size: 34px;
        line-height: 52px;
        color: #545454;
        text-align: left;
        margin-top: 100px;
        font-weight: 700;

        .line {
          width: 64px;
          height: 4px;
          background-color: #c30000;
          margin-top: 16px;
        }
      }

      .contentBox {
        width: 822px;
        background-color: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        padding: 20px;
        font-weight: 400;
        margin-top: 178px;
        text-align: left;

        .tips {
          font-size: 18px;
          color: #333333;
          line-height: 30px;

        }

        .item {
          color: #545454;
          font-size: 16px;
          line-height: 28px;
        }

        .cons {
          margin-top: 30px;
        }

        .item1 {
          font-size: 16px;
          line-height: 24px;
          color: #545454;
        }
      }
    }

    .commBox.right {
      flex-direction: row-reverse;
    }

    .sectionItem {
      width: 100%;
      height: 400px;
      background-color: #fbfbfb;
      margin-bottom: 560px;

      .innerBox {
        height: 100%;

      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/joinUsEn.vue